import { createAction } from '@reduxjs/toolkit'
import { ToastMessage } from 'primereact/toast'

export const startLoading = createAction('layout/startLoading')

export const endLoading = createAction('layout/endLoading')

export const showToast = createAction<ToastMessage>('layout/showToast')
